import { ACCOUNT_INFORMATION } from '../../../../../../../../constants/formInputs';

export type AccountInfo = Record<ACCOUNT_INFORMATION, string>;

export enum OTP_VERIFICATION {
  'SMS' = 'SMS',
  'SMS_USSD' = 'SMS_USSD'
}

export enum UPDATE_ACCOUNT_DIALOG_STEPS {
  'EDIT_FORM' = 'EDIT_FORM',
  'OTP_VERIFICATION_SMS_OR_SMS_AND_USSD' = 'OTP_VERIFICATION_SMS_OR_SMS_AND_USSD'
}

export interface OtpValue {
  smsOtp: string;
}

export enum BUSINESS_ERRORS {
  'INCORRECT_OTP' = 'INCORRECT_OTP',
  'MISSING_OTP' = 'MISSING_OTP',
  'ORDER_NOT_FOUND' = 'ORDER_NOT_FOUND',
  'MSISDN_ALREADY_USED' = 'MSISDN_ALREADY_USED',
  'INCORRECT_MSISDN' = 'INCORRECT_MSISDN',
  'OTP_EXPIRED' = 'OTP_EXPIRED',
  'OTP_COULD_NOT_BE_SEND' = 'OTP_COULD_NOT_BE_SEND',
  'OTP_EXHAUSTED_LIMIT' = 'OTP_EXHAUSTED_LIMIT',
  'OTP_DELIVERY_FAILURE' = 'OTP_DELIVERY_FAILURE',
  'SERVER_DOES_NOT_RESPOND' = 'SERVER_DOES_NOT_RESPOND',
  'OTP_RESEND_BLOCKED' = 'OTP_RESEND_BLOCKED'
}
